import React from 'react';
import { OrderingConstants, OrderingSelectors } from 'polygon-ordering';
import { useAppSelector } from '../app/hooks';
import PaymentWrapper from '../components/PaymentProvider';
import { TyroProvider } from '../hooks/TyroProvider';
import { RedcatPaymentProvider } from '../shared/redcatpayments/RedcatPaymentProvider';
import PurchaseGiftCardScreen from './PurchaseGiftCardScreen';

export { PURCHASE_GIFT_CARD_ROUTE } from '../constants/loyaltyRoutes';

const { getGatewayType } = OrderingSelectors;
const { PAYMENT_GATEWAY_TYPES } = OrderingConstants;

const PurchaseGiftCardScreenWrapper = () => {
  const gatewayType = useAppSelector(getGatewayType);
  const enableReCaptchaForGiftCard = useAppSelector(
    (state: any) => state.config.enableReCaptchaForGiftCard,
  );
  const reCaptchaSiteKey = useAppSelector((state: any) => state.config.reCaptchaSiteKey);

  if (gatewayType === PAYMENT_GATEWAY_TYPES.REDCAT_PAY) {
    return (
      <RedcatPaymentProvider
        requireRecaptcha={enableReCaptchaForGiftCard}
        recaptchaSiteKey={reCaptchaSiteKey}
        purchaseType="giftcard_purchase"
      >
        <PurchaseGiftCardScreen />
      </RedcatPaymentProvider>
    );
  }

  let PaymentProviderWrapper: any;

  if (gatewayType === PAYMENT_GATEWAY_TYPES.STRIPE) {
    PaymentProviderWrapper = PaymentWrapper;
  } else if (gatewayType === PAYMENT_GATEWAY_TYPES.TYRO) {
    PaymentProviderWrapper = TyroProvider;
  }

  return PaymentProviderWrapper ? (
    <PaymentProviderWrapper>
      <PurchaseGiftCardScreen />
    </PaymentProviderWrapper>
  ) : (
    <PurchaseGiftCardScreen />
  );
};

export default PurchaseGiftCardScreenWrapper;
